import React from "react";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { DataTable } from "components/support";
import { fn } from "util";

const config = {
  identifier: "name",
  columns: [
    {
      accessor: "_id.name",
      Header: "Nome"
    },
    {
      id: "count",
      accessor: row => fn.centsToReal(row.count * 100), //TODO padronizar o local onde se multiplica ou divide por 100.
      Header: "Qtd.",
      align: "right"
    }
  ]
};

class MostSold extends React.Component {
  render() {
    return (
      <div>
        <Typography type="headline">Mais vendidos</Typography>
        <Paper elevation={1}>
          <DataTable
            resultSet={this.props.result.most_sold_products}
            config={config}
            showPagination={false}
          />
        </Paper>
      </div>
    );
  }
}

export default MostSold;



// WEBPACK FOOTER //
// ./src/components/app/history/dashboard/most-sold/view.jsx